import {
  IconBlocks,
  IconChartBar,
  IconHome,
  IconSettings,
  IconUserEdit,
  IconUsers,
} from '@tabler/icons-react'

import ChatterReportsPage from '@/components/feature/analytics/chatter-reports'
import CreatorReportsPage from '@/components/feature/analytics/creator-reports'
import FansReportsPage from '@/components/feature/analytics/fans-reports'
import ManageCreators from '@/components/feature/creators/manage-creators'
import ManageEmployees from '@/components/feature/employees/manage-employees'
import Home from '@/components/feature/home'
import NewPost from '@/components/feature/posts/new-post'
import Posts from '@/components/feature/posts/post'
import SettingsPage from '@/components/feature/settings/settings'
import VaultPage from '@/components/feature/vault/vault'
import { FeatureKey } from '@/constants/feature-key'
import { MenuConfig } from '@/utils/menu'

export const menuConfig: MenuConfig = {
  [FeatureKey.Home]: {
    icon: IconHome,
    page: Home,
  },
  [FeatureKey.OFManager]: {
    icon: IconBlocks,
  },
  [FeatureKey.NewPost]: {
    page: NewPost,
  },
  [FeatureKey.Posts]: {
    page: Posts,
  },
  [FeatureKey.Vault]: {
    page: VaultPage,
  },
  [FeatureKey.Messages]: {
  },
  [FeatureKey.Analytics]: {
    icon: IconChartBar,
  },
  [FeatureKey.CreatorReports]: {
    page: CreatorReportsPage,
  },
  [FeatureKey.AnalyticsCreatorOverview]: {
    page: CreatorReportsPage,
    hideInMenu: true,
  },
  [FeatureKey.ChatterReports]: {
    page: ChatterReportsPage,
  },
  [FeatureKey.ChatterReportsOverview]: {
    page: ChatterReportsPage,
    hideInMenu: true,
  },
  [FeatureKey.ChattersPerformance]: {
    page: ChatterReportsPage,
    hideInMenu: true,
  },
  [FeatureKey.FansReports]: {
    page: FansReportsPage,
  },
  [FeatureKey.Creators]: {
    icon: IconUserEdit,
  },
  [FeatureKey.ManageCreators]: {
    page: ManageCreators,
  },
  [FeatureKey.Employees]: {
    icon: IconUsers,
  },
  [FeatureKey.ManageEmployees]: {
    page: ManageEmployees,
  },
  [FeatureKey.Settings]: {
    icon: IconSettings,
    page: SettingsPage,
    hideInMenu: true,
  },
  [FeatureKey.SalesSettings]: {
    icon: IconChartBar,
    page: SettingsPage,
  },
  [FeatureKey.RoleSettings]: {
    icon: IconUsers,
    page: SettingsPage,
  },
}
